import React from 'react';
import { HistogramChart } from "@carbon/charts-react";
import { useTranslation } from "react-i18next";
import ChartPanelWrapper from "../ChartPanelWrapper";
import { transformToGroupValue, expandHistogramBuckets, resolveGroupLabel, resolveFields, buildChartTitle, buildXAxisTitle, buildYAxisTitle, getChartColorPalette } from "../chartHelpers";
import './_index.scss'

const Index = ({chart}) => {
    const { t } = useTranslation();
    return (
        <ChartPanelWrapper chart={chart}>
            {(panelData) => {
                const gv = transformToGroupValue(panelData, chart);
                const { valueField } = resolveFields(chart, panelData[0]);
                const groupLabel = resolveGroupLabel(chart, valueField, t('panels.observation'));
                const data = expandHistogramBuckets(gv, groupLabel);
                const colorPalette = getChartColorPalette();
                const chartOptions = {
                    title: buildChartTitle(chart),
                    resizable: true,
                    height: "400px",
                    axes: {
                        bottom: {
                            title: buildXAxisTitle(chart),
                            mapsTo: "value",
                            bins: 10,
                            limitDomainToBins: true
                        },
                        left: {
                            title: buildYAxisTitle(chart),
                            scaleType: "linear",
                            stacked: true,
                            binned: true
                        }
                    },
                    color: { scale: { [groupLabel]: colorPalette[0] } }
                };
                return <HistogramChart options={chartOptions} data={data} />;
            }}
        </ChartPanelWrapper>
    );
}

export default React.memo(Index)
